import { gql } from '../../__generated__'

export const GET_RELEASE_ITEMS = gql(/* GraphQL */ `
  query GetReleaseItems(
    $where: ReleaseItemWhereInput!
    $orderBy: [ReleaseItemOrderByInput!]!
    $take: Int
    $skip: Int!
  ) {
    releaseItems(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
      id
      number
      volumeSuffix
      isbn
      title
      price
      publisherName
      localizedSeriesTitle
      cover
      thumbHash
      originalCover
      releaseDate
      releaseDateAccuracy
      entryId
      extrasNote
      extrasOnlyOnFirstEdition
      pages
      size
      format
      description {
        document
      }
      publisherDescription {
        document
      }
    }
  }
`)

export const GET_VOLUME_SUFFIXES = gql(/* GraphQL */ `
  query GetVolumeSuffixes {
    volumeSuffixes(orderBy: [{ name: asc }]) {
      id
      name
      abbreviation
    }
  }
`)

export const GET_RELEASE_ITEM_COLLECTIONS = gql(/* GraphQL */ `
  query GetReleaseItemCollections(
    $where: ReleaseItemCollectionWhereInput!
    $orderBy: [ReleaseItemCollectionOrderByInput!]!
    $skip: Int
    $take: Int
  ) {
    releaseItemCollections(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
      id
      number
      volumeSuffix
      isbn
      price
      name
      localizedSeriesTitle
      publisherName
      format
      size
      pages
      description {
        document
      }
      publisherDescription {
        document
      }
      extrasNote
      releaseItems {
        id
        number
        volumeSuffix
        entryId
        localizedSeriesTitle
      }
      cover
      thumbHash
      releaseDate
      releaseDateAccuracy
      entryId
    }
  }
`)

export const GET_NOVELTIES = gql(/* GraphQL */ `
  query getNovelties(
    $where: NoveltyWhereInput!
    $orderBy: [NoveltyOrderByInput!]!
    $take: Int
    $skip: Int!
  ) {
    novelties(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
      id
      number
      volumeSuffix
      isbn
      romanizedSeriesTitle
      price
      publisherName
      localizedSeriesTitle
      cover
      thumbHash
      releaseDate
      releaseDateAccuracy
      entryId
      relationType
      relationId
      releaseItems
    }
  }
`)

export const GET_CATALOG_CHANGES = gql(/* GraphQL */ `
  query getCatalogChanges(
    $sinceSeq: String!
    $subscription: CatalogSubscriptionInput!
    $limit: Int
  ) {
    catalogChanges(sinceSeq: $sinceSeq, subscription: $subscription, limit: $limit) {
      nextSeq
      headSeq
      hasMore
      resyncRequired
      tombstones {
        entity
        rowId
      }
      novelties {
        id
        number
        volumeSuffix
        isbn
        romanizedSeriesTitle
        price
        publisherName
        localizedSeriesTitle
        cover
        thumbHash
        releaseDate
        releaseDateAccuracy
        entryId
        relationType
        relationId
        releaseItems
        type
        releaseYear
        releaseMonth
        disabled
        titleSearch
        tagSearchField
        demographySearchField
      }
      releaseEntries {
        id
        internalName
        disabled
        status
        cover
        thumbHash
        endDate
        startDate
        releaseYear
        releaseMonth
        yearMonthKey
        popularityScore
        recommendationScore
        firstVolumeNumber
        sortedVolumeNumbers
        notReleasedVolumeNumbers
        totalVolumes
        totalNotReleasedVolumes
        totalReleasedVolumes
        publisherName
        publisherHistory
        type
        creationDate
        updatedDate
        needsToBeCheckedReason
        tagSearchField
        demographySearchField
        titleSearch
        description {
          document
        }
        seriesInfo {
          id
        }
        size {
          id
        }
        staffs {
          id
        }
        material {
          id
        }
      }
      releaseItems {
        id
        disabled
        disableNovelty
        entryId
        publisherName
        type
        localizedSeriesTitle
        romanizedSeriesTitle
        volumeSuffix
        cover
        thumbHash
        originalCover
        number
        title
        isbn
        originalIsbn
        releaseDateAccuracy
        releaseDate
        releaseYear
        releaseMonth
        yearMonthKey
        extrasOnlyOnFirstEdition
        price
        creationDate
        updatedDate
        needsToBeCheckedReason
        extrasNote
        notes
        pages
        format
        currentEditionNumber
        color
        size
        tagSearchField
        description {
          document
        }
        publisherDescription {
          document
        }
      }
      releaseItemCollections {
        id
        name
        cover
        thumbHash
        entryId
        publisherName
        type
        localizedSeriesTitle
        romanizedSeriesTitle
        disabled
        itemsOnlyExistInThisCollection
        volumeSuffix
        number
        isbn
        releaseDateAccuracy
        releaseDate
        releaseYear
        releaseMonth
        price
        extrasNote
        notes
        pages
        format
        currentEditionNumber
        color
        size
        tagSearchField
        description {
          document
        }
        publisherDescription {
          document
        }
        releaseItems {
          id
        }
      }
      publishers {
        id
        name
        disabled
        publisherChangeEvents
        sortOrder
        url
        vlbId
        vlbKeyword
        vlbSubjectFilter
        vlbTitleFilter
        colorLightTheme
        colorDarkTheme
        longName
        lastUpdateRun
        defaultVlbTextTypeCodes
        connector
        betterCoverProvider
      }
      tags {
        id
        name
        sortNumber
        tagType
        promotionStartDate
        promotionEndDate
      }
      demographies {
        id
        name
      }
      volumeSuffixes {
        id
        name
        abbreviation
      }
      seriesInfos {
        id
        country
        originalTitle
        romanizedTitle
        type
        status
        startYear
        description {
          document
        }
        staffs {
          id
        }
        tags {
          id
        }
        demography {
          id
        }
        jpPublishers {
          id
        }
        magazines {
          id
        }
      }
      staffEntries {
        id
        label
        originalVlb71Code
        individual {
          id
        }
        job {
          id
        }
      }
      individuals {
        id
        exId
        name
        firstName
        middleNames
        lastName
        birthDate
        handle
        disambiguator
      }
      jobs {
        id
        title
        vlb71Codes
      }
      magazines {
        id
        name
      }
      jpPublishers {
        id
        name
      }
      sizeInfos {
        id
        label
        sizeAliasName
        width
        height
        depth
      }
      materialInfos {
        id
        name
        description {
          document
        }
      }
      databaseListConfigs {
        id
        urlName
        nameDe
        nameEn
        subtitleDe
        subtitleEn
        mode
        listType
        filter
        sort
        ignoredFilterPropsForChangeDetection
        hideSearch
        enabled
        order
      }
      databaseListReleaseEntries {
        id
        orderNumber
        compoundKey
        databaseList {
          id
        }
        releaseEntry {
          id
        }
      }
    }
  }
`)

export const GET_FILTERED_NOVELTIES = gql(/* GraphQL */ `
  query getFilteredNovelties(
    $where: NoveltyWhereInput!
    $orderBy: [NoveltyOrderByInput!]!
    $take: Int
    $skip: Int!
    $filterMode: String
  ) {
    filteredNovelties(
      where: $where
      orderBy: $orderBy
      take: $take
      skip: $skip
      filterMode: $filterMode
    ) {
      id
      number
      volumeSuffix
      isbn
      romanizedSeriesTitle
      price
      publisherName
      localizedSeriesTitle
      cover
      thumbHash
      releaseDate
      releaseDateAccuracy
      entryId
      relationType
      relationId
      releaseItems
      collectionVolumeInfo {
        volumeCount
        spansEntries
      }
    }
  }
`)

export const GET_TAGS = gql(/* GraphQL */ `
  query GetTags($orderBy: [TagOrderByInput!]!) {
    tags(orderBy: $orderBy) {
      id
      name
      tagType
      promotionStartDate
      promotionEndDate
    }
  }
`)

export const GET_DEMOGRAPHIES = gql(/* GraphQL */ `
  query GetDemographies($orderBy: [DemographyOrderByInput!]!) {
    demographies(orderBy: $orderBy) {
      id
      name
    }
  }
`)

export const GET_PUBLISHERS = gql(/* GraphQL */ `
  query GetPublishers($orderBy: [PublisherOrderByInput!]!, $where: PublisherWhereInput!) {
    publishers(orderBy: $orderBy, where: $where) {
      id
      name
      url
      colorDarkTheme
      colorLightTheme
    }
  }
`)

export const GET_USER_ADMIN = gql(/* GraphQL */ `
  query GetUserAdmin {
    userAdmins {
      id
      userId
      adSkipTokens
      isTester
      premiumTier
      premiumStartDate
      premiumLastRenewalDate
      user {
        id
      }
    }
  }
`)

export const GET_MISSING_ISBNS = gql(/* GraphQL */ `
  query GetMissingIsbns($where: MissingIsbnWhereInput!) {
    missingIsbns(where: $where) {
      id
      userExplanation
    }
  }
`)

export const CREATE_MISSING_ISBN = gql(/* GraphQL */ `
  mutation Mutation($data: MissingIsbnCreateInput!) {
    createMissingIsbn(data: $data) {
      id
    }
  }
`)

export const UPDATE_MISSING_ISBN = gql(/* GraphQL */ `
  mutation UpdateMissingIsbn($where: MissingIsbnWhereUniqueInput!, $data: MissingIsbnUpdateInput!) {
    updateMissingIsbn(where: $where, data: $data) {
      id
    }
  }
`)

export const USER_GET_EXISTING_COLLECTIONS = gql(/* GraphQL */ `
  query GetUserExistingCollections {
    users {
      id
      collection {
        id
        collectionStatus
        currentReadStatus
        startDate
        endDate
        entry {
          id
          status
          sortedVolumeNumbers
          notReleasedVolumeNumbers
          totalReleasedVolumes
          startDate
          endDate
        }
        itemStatus
        miscItemStatus
        readStatus {
          id
          finishedRead
          readStatus
          startedRead
          status
        }
      }
    }
  }
`)

export const GET_RELEASE_ENTRY = gql(/* GraphQL */ `
  query GetReleaseEntry($where: ReleaseEntryWhereUniqueInput!) {
    releaseEntry(where: $where) {
      internalName
      publisherName
      id
    }
  }
`)

export const GET_RELEASE_ENTRIES = gql(/* GraphQL */ `
  query GetReleaseEntries(
    $where: ReleaseEntryWhereInput!
    $orderBy: [ReleaseEntryOrderByInput!]!
    $take: Int
    $skip: Int!
  ) {
    releaseEntries(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
      cover
      thumbHash
      id
      status
      internalName
      type
      publisherName
      startDate
      sortedVolumeNumbers
      notReleasedVolumeNumbers
      totalReleasedVolumes
    }
  }
`)

export const GET_COLLECTION_ENTRIES = gql(/* GraphQL */ `
  query UserCollectionEntries(
    $where: UserReleaseEntryStatusWhereInput!
    $orderBy: [UserReleaseEntryStatusOrderByInput!]!
    $take: Int
    $skip: Int!
  ) {
    userReleaseEntryStatuses(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
      id
      entry {
        id
        type
        cover
        thumbHash
        status
        sortedVolumeNumbers
        notReleasedVolumeNumbers
        totalReleasedVolumes
      }
      currentReadStatus
      internalName
      publisherName
      startDate
      endDate
    }
  }
`)

export const GET_FILTERED_COLLECTION_ENTRIES = gql(/* GraphQL */ `
  query FilteredUserCollectionEntries(
    $where: UserReleaseEntryStatusWhereInput!
    $orderBy: [UserReleaseEntryStatusOrderByInput!]!
    $take: Int
    $skip: Int!
    $filterMode: String
  ) {
    filteredUserReleaseEntryStatuses(
      where: $where
      orderBy: $orderBy
      take: $take
      skip: $skip
      filterMode: $filterMode
    ) {
      id
      entry {
        id
        type
        cover
        thumbHash
        status
        sortedVolumeNumbers
        notReleasedVolumeNumbers
        totalReleasedVolumes
      }
      currentReadStatus
      internalName
      publisherName
      startDate
      endDate
    }
  }
`)

export const UPDATE_USER_COLLECTION = gql(/* GraphQL */ `
  mutation UpdateUserCollection(
    $where: UserReleaseEntryStatusWhereUniqueInput!
    $data: UserReleaseEntryStatusUpdateInput!
  ) {
    updateUserReleaseEntryStatus(where: $where, data: $data) {
      entry {
        internalName
        id
      }
      id
    }
  }
`)

export const REMOVE_USER_COLLECTION = gql(/* GraphQL */ `
  mutation RemoveUserCollection(
    $where: UserReleaseEntryStatusWhereUniqueInput!
    $eventDate: DateTime!
  ) {
    deleteUserReleaseEntryStatusWithEvent(where: $where, eventDate: $eventDate) {
      id
    }
  }
`)

export const UPDATE_USER_READ_STATUS = gql(/* GraphQL */ `
  mutation UpdateReadStatus(
    $where: UserReleaseReadStatusWhereUniqueInput!
    $data: UserReleaseReadStatusUpdateInput!
  ) {
    updateUserReleaseReadStatus(where: $where, data: $data) {
      id
    }
  }
`)

export const CREATE_USER_COLLECTION = gql(/* GraphQL */ `
  mutation CreateUserCollection($data: UserReleaseEntryStatusCreateInput!) {
    createUserReleaseEntryStatus(data: $data) {
      id
      entry {
        id
        internalName
      }
      readStatus {
        id
      }
    }
  }
`)

export const GET_SHARED_COLLECTION_SIBLING_ENTRIES = gql(/* GraphQL */ `
  query GetSharedCollectionSiblingEntries($where: ReleaseItemCollectionWhereInput!) {
    releaseItemCollections(where: $where) {
      id
      sharedGroup {
        id
        collections {
          id
          entryId
        }
      }
    }
  }
`)

export const GET_SINGLE_USER_COLLECTION = gql(/* GraphQL */ `
  query GetSingleUserCollection($where: UserReleaseEntryStatusWhereInput!) {
    userReleaseEntryStatuses(where: $where, take: 1) {
      id
      collectionStatus
      currentReadStatus
      entry {
        id
        status
        internalName
        sortedVolumeNumbers
        notReleasedVolumeNumbers
        startDate
        endDate
      }
      itemStatus
      miscItemStatus
      readStatus {
        id
        finishedRead
        readStatus
        startedRead
        status
      }
    }
  }
`)

export const GET_RELEASE_ENTRY_ID_FROM_ITEM = gql(/* GraphQL */ `
  query GetReleaseEntryIDFromISBN($where: ReleaseItemWhereInput!) {
    releaseItems(where: $where) {
      number
      volumeSuffix
      entryId
      localizedSeriesTitle
      isbn
    }
  }
`)

export const GET_USER_NOTIFICATION_TOKENS = gql(/* GraphQL */ `
  query GetUserNotificationTokens {
    users {
      id
      notificationFcmTokens
    }
  }
`)

export const UPDATE_USER_NOTIFICATION_TOKENS = gql(/* GraphQL */ `
  mutation UpdateUserNotificationTokens($where: UserWhereUniqueInput!, $data: UserUpdateInput!) {
    updateUser(where: $where, data: $data) {
      id
      notificationFcmTokens
    }
  }
`)

export const GET_NOVELTY_BY_ISBN = gql(/* GraphQL */ `
  query GetNoveltyByISBN($where: NoveltyWhereInput!) {
    novelties(where: $where, orderBy: [], skip: 0, take: 1) {
      id
      number
      volumeSuffix
      entryId
      relationType
      relationId
      releaseItems
    }
  }
`)

export const GET_NOVELTIES_BY_ISBNS = gql(/* GraphQL */ `
  query GetNoveltiesByISBNs($where: NoveltyWhereInput!) {
    novelties(where: $where, orderBy: [], skip: 0, take: 500) {
      id
      isbn
      number
      volumeSuffix
      entryId
      relationType
      relationId
      localizedSeriesTitle
      publisherName
      cover
      thumbHash
    }
  }
`)

export const GET_RELEASE_ENTRY_WITH_SERIES_INFO = gql(/* GraphQL */ `
  query GetReleaseEntriesWithSeriesInfo($where: ReleaseEntryWhereUniqueInput!) {
    releaseEntry(where: $where) {
      id
      internalName
      type
      cover
      thumbHash
      publisherName
      status
      sortedVolumeNumbers
      notReleasedVolumeNumbers
      totalReleasedVolumes
      startDate
      endDate
      releaseItemsCount
      size {
        id
        sizeAliasName
        width
        height
        depth
      }
      material {
        id
        name
      }
      description {
        document
      }
      seriesInfo {
        id
        status
        jpPublishers {
          id
          name
        }
        magazines {
          id
          name
        }
        originalTitle
        romanizedTitle
        country
        tags {
          id
          name
        }
        demography {
          id
          name
        }
        staffs {
          id
          job {
            id
            title
          }
          individual {
            id
            name
          }
        }
      }
      staffs {
        id
        job {
          id
          title
        }
        individual {
          id
          name
        }
      }
      releaseCollections {
        id
        number
      }
    }
  }
`)
